import { State as DataState } from '@progress/kendo-data-query';
import { produce } from 'immer';
import { useState } from 'react';
import { getSkip } from '../../../../../../common/widgets/Grid';
import { config } from '../../../../config';
import { SubscriptionItemModel } from '../../../../models/Subscriptions';
import { SubscriptionGrid } from './SubscriptionsGrid';

interface SubscriptionsPageState {
  subscriptions: {
    data?: SubscriptionItemModel[];
    total: number;
    dataState: DataState;
  };
  showErrorPanel?: boolean;
}

export const SubscriptionsForDashboard = () => {
  const [state, setState] = useState<SubscriptionsPageState>({
    subscriptions: {
      total: 0,
      dataState: {
        skip: 0,
        take: config.grid.defaultPageSize,
        sort: [{ field: 'dateAdded', dir: 'desc' }],
      },
    },
  });

  const onDataStateChange = (dataState: DataState) => {
    setState(
      produce(draft => {
        draft.subscriptions.dataState = {
          ...dataState,
          skip: getSkip(draft.subscriptions.dataState, dataState),
        };
      }),
    );
  };

  const onDataReceived = (data: any, showErrorPanel?: boolean) => {
    setState(
      produce(draft => {
        draft.subscriptions.data = data.data;
        draft.subscriptions.total = data.total;
        draft.showErrorPanel = showErrorPanel;
      }),
    );
  };

  const onSubscriptionCanceled = (orderProductId: number) => {
    setState(
      produce(draft => {
        draft.subscriptions.data = draft.subscriptions.data?.filter(
          e => e.orderProductId !== orderProductId,
        );
      }),
    );
  };

  return (
    <SubscriptionGrid
      subscriptions={{
        ...state.subscriptions,
        onDataReceived,
        onDataStateChange,
        onSubscriptionCanceled,
      }}
      showErrorPanel={state.showErrorPanel}
      isForDashboard={true}
    />
  );
};
